import { render, staticRenderFns } from "./currentLocation.vue?vue&type=template&id=348cfcc1&scoped=true"
import script from "./currentLocation.vue?vue&type=script&lang=js"
export * from "./currentLocation.vue?vue&type=script&lang=js"
import style0 from "./currentLocation.vue?vue&type=style&index=0&id=348cfcc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348cfcc1",
  null
  
)

export default component.exports